import {UserAmsRole, UserFilterInput, UserSortingField} from 'modules/decisionsNext/api/types';
import {SortOrder} from 'types';

import {FeatureFlags} from 'core/constants/featureFlags';
import {useFeatureFlag} from 'core/hooks/authHooks';
import {useUserTreeQuery} from 'modules/decisionsNext/api/trees/userTree.generated';
import {BE_MAX_PAGINATION_LIMIT} from 'modules/decisionsNext/constants';

export const ALL_TEAMS_KEY = 'all';

export function useAllUsers(filter: UserFilterInput = {}, skip?: boolean) {
  const withAmsCodes = useFeatureFlag(FeatureFlags.AmsProducerCodes);

  return useUserTreeQuery({
    variables: {
      limit: BE_MAX_PAGINATION_LIMIT,
      sortBy: UserSortingField.FullName,
      sortOrder: SortOrder.Asc,
      withAmsCodes,
      filter,
    },
    skip,
    disableSkipSetsLoadingState: true,
  });
}

export const idSeparator = '__%%__';

type InternalId = {
  userId: string;
  role: UserAmsRole;
  amsCodeId?: string;
};

export function getInternalId({userId, role, amsCodeId = ''}: InternalId) {
  return [userId, amsCodeId, role].join(idSeparator);
}

export function getOriginalId(internalId: string) {
  return internalId.split(idSeparator);
}
